const config = {
  reactAppUrl: process.env.REACT_APP_URL,
  HEART_BEAT_INTERVAL:parseInt(process.env.REACT_APP_HEART_BEAT_INTERVAL || "40000")
};

export function getAzureQueueApps() {
  const env = process.env.REACT_APP_AZURE_QUEUE;
  if (!env) return [];
  try {
    return JSON.parse(env); 
  } catch {
    return [];
  }
}

export function getAzureQueueTopics(): string[] {
  return [
   'appice-metadata',
   'appice-data',
   'appice-jobdata-data',
   'appice-campaign-data',
   'appice-appinbox-data',
   'appice-campaign-received-events-data',
   'appice-campaign-processor',
   'appice-citus-error-data',
   'appice-custom-segment-data',
   'appice-install-events-data',
   'appice-error-event-queue',
   'appice-priority-data',
   'appice-transactional-campaign-data-'
  ];
}

export function getPgQueueApps() {
  const env = process.env.REACT_APP_PG_QUEUE;
  if (!env) return [];
  try {
    return JSON.parse(env); 
  } catch {
    return [];
  }
}

export function getPgQueueTopics(): string[] {
  return [
    'campaigntransactional',
  ];
}

export default config